export default "__VITE_ASSET__zUMv05Up__"